import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const workerPaySettingService = {
  getList,
  save,
};

// One row per active, user-linked worker with their pay/OT settings (defaults
// where unset).
function getList(propertyId) {
  return axios
    .get(apiEndpoint.workerPaySettings, {
      headers: authHeader(),
      params: { property_id: propertyId },
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return { workers: [] };
    });
}

// Upsert one worker's pay/OT settings (owner/admin only server-side).
function save(data) {
  return axios
    .post(apiEndpoint.workerPaySettings, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}
